export default __webpack_public_path__ + "91d56e77eb5cdf5890a5c716eaef23e4.svg";